// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","510":"component---src-pages-terms-js","745":"component---src-pages-privacy-js"}[chunkId] || chunkId) + "-" + {"293":"f0c88f0c8c0061180eda","510":"0fde646cf2745c75228d","745":"b145244afa90432498f2","878":"5438cfc34d1d9cf1acf6"}[chunkId] + ".js";
};